import { render, staticRenderFns } from "./SynthsPositionsList.vue?vue&type=template&id=2dfa3fcf&"
import script from "./SynthsPositionsList.vue?vue&type=script&lang=js&"
export * from "./SynthsPositionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports